import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table'
import {getSchoolGrades, groupBy, showFile, _addNotificationError} from '../../../../server/util'
import { get } from '../../../../server/actions'
import Datetime from 'react-datetime'
import '../../../../../node_modules/react-datetime/css/react-datetime.css'
import moment from  'moment';
import TmExportExcel from '../../../Misc/tmExportExcel/tmExportExcel';
import { date_format } from '../../../../server/constants';
import Select from 'react-select';
require('moment')
let download = require('downloadjs');
const enumMealType = {
    lunch: 'Lunch',
    breakfast: 'Breakfast',
    //milk: 'Milk',
    snack: 'Snack'
}

var currentMonth=moment().format("MMMM YYYY");
//console.log("currentMonth : ",moment(currentMonth).format("YYYY-MM"));

class FRLReport extends Component {
    constructor(props){
        super(props);
        console.log("Report page:::", props);
        this.state={
            data:[],
            mealTypes: enumMealType.lunch,
            selectedGrade: '',
            selectedOptions: [],
            selectMonth: moment().format("YYYY-MM"),
            startDate: moment().startOf('month').format('YYYY-MM-DDT00:00:00'),
            endDate: moment().endOf('month').format("YYYY-MM-DDT23:59:59"),
            teacherName: '',
        }
        //this.getData("Lunch");
    }
    componentDidMount=()=>{
        this.getData(this.state.mealTypes, this.state.startDate, this.state.endDate);
    }
    // btnExportExcelOnClick=(e)=>{
    //     const btn=document.getElementById('btnExportExcel');
    //     if(btn){
    //         btn.click();
    //     }
    // }
    getFRLReportsPdf = (mType,fType) => {
        console.log("Select Month : ",this.state.selectMonth);
        var dt = moment(this.state.selectMonth, "YYYY-MM");
        let startDate = moment(dt).startOf('month').format('YYYY-MM-DDT00:00:00');
        let endDate = moment(dt).endOf('month').format("YYYY-MM-DDT23:59:59");
        let yearMonth = moment(dt).endOf('month').format("YYYYMM");
        let _gradeStr=this.state.selectedGrade===''?'':'&grades='+this.state.selectedGrade;
        let _teacherStr=this.state.teacherName.trim()===''?'':'&teacherName='+encodeURIComponent(this.state.teacherName.trim());
        this.setState({ loading: true });
        get(`/reports/generateFRLReport/${sessionStorage.getItem('SchoolId')}/${mType}?startDate=${startDate}&endDate=${endDate}&yearMonth=${yearMonth}&fileType=${fType}${_gradeStr}${_teacherStr}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            this.setState({ loading: false });
            return response.blob();
        }).then(blob => {
            if(fType == 'excel'){
                this.setState({loading: false})
                let filename = `${this.state.mealTypes}FRLReport`;
            download(blob,
                filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            }else{
                let filename = "FRL Reports for ";
                showFile(blob, filename);
            }
        }).catch(error => {
            this.setState({ loading: false });
            console.log("Download Failed", error)
        })
    };
    getData = (mType, startDate, endDate) => {
        console.log("Select Month : ",this.state.selectMonth);
        let yearMonth = moment(startDate, 'YYYY-MM-DDT00:00:00').format("YYYYMM");
        let _gradeStr=this.state.selectedGrade===''?'':'&grades='+this.state.selectedGrade;
        let _teacherStr=this.state.teacherName.trim()===''?'':'&teacherName='+encodeURIComponent(this.state.teacherName.trim());
       // console.log("_gradeStr::::::::",_gradeStr);
        this.props.showHideLoading( true);
        get(`/reports/generateFRLReport/${sessionStorage.getItem('SchoolId')}/${mType}?startDate=${startDate}&endDate=${endDate}&yearMonth=${yearMonth}${_gradeStr}${_teacherStr}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
           }).then(data => {
        let tableData = [];
            for( const[key, val] of Object.entries(data.resp)){
                let rowData = {};
                //let keyDate = this.state.selectMonth+"-"+key;
                let keyDate = moment(this.state.selectMonth+"-"+key, "YYYY-MM-DD");
                rowData["date"] = moment(keyDate).format(date_format());
                for(let record of val){
                    if(record.elig == 0){
                        rowData["freeMealServedQty"] = record.mealQty;
                        rowData["freeCarteServedQty"] = record.extraQty;                        
                    } else if(record.elig == 1){
                        rowData["redMealServedQty"] = record.mealQty;
                        rowData["redCarteServedQty"] = record.extraQty;   
                    } else if(record.elig == 2){
                        rowData["regMealServedQty"] = record.mealQty;
                        rowData["regCarteServedQty"] = record.extraQty;   
                    }
                }
                rowData["freeMealServedQty"] = rowData["freeMealServedQty"]?  rowData["freeMealServedQty"]: 0;
                rowData["freeCarteServedQty"] = rowData["freeCarteServedQty"]? rowData["freeCarteServedQty"]:0;
                rowData["redMealServedQty"] = rowData["redMealServedQty"]? rowData["redMealServedQty"] : 0;
                rowData["redCarteServedQty"] = rowData["redCarteServedQty"] ? rowData["redCarteServedQty"] : 0;
                rowData["regMealServedQty"] = rowData["regMealServedQty"]? rowData["regMealServedQty"]: 0;
                rowData["regCarteServedQty"] = rowData["regCarteServedQty"]? rowData["regCarteServedQty"]: 0;

                tableData.push(rowData);
            }
            this.setState({data:tableData});
            this.props.showHideLoading( false);
        }).catch(error => {
            this.props.showHideLoading( false);
            console.log("Loading Report Failed", error)
        })
    };

    getColumns = () => {
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        console.log("gradeGroup::::::::::::::",gradeGroup);
        let columns=[
            { Header: "DATE", accessor: "date" },
            { Header: "FREE ELIGIBILITY", columns:[
                {Header:"Meal Served Qty",accessor:"freeMealServedQty"},
                {Header:"A La Carte Served Qty",accessor:"freeCarteServedQty"}
            ] }, 
            { Header: "REDUCED ELIGIBILITY", columns:[
                {Header:"Meal Served Qty",accessor:"redMealServedQty"}, 
                { Header:"A La Carte Served Qty",accessor:"redCarteServedQty"}
            ] },
            { Header: "REGULAR ELIGIBILITY", columns:[{Header:"Meal Served Qty",accessor:"regMealServedQty"},
            { Header:"A La Carte Served Qty",accessor:"regCarteServedQty"}], style: { textAlign: 'center', textTransform: 'capitalize' } } 
        ];
        return columns
    }

    // buildDataFormatForExport = () => {
    //     //const gradeGroup=groupBy(getSchoolGrades(0,false),'value');
    //     return (
    //       [{
    //         columns: [
    //             { Header: "DATE", accessor: "date" },
    //             { Header: "FREE ELIGIBILITY", columns:[
    //                 {Header:"Meal Served Qty",accessor:"freeMealServedQty"},
    //                 {Header:"A La Carte Served Qty",accessor:"freeCarteServedQty"}
    //             ] }, 
    //             { Header: "REDUCED ELIGIBILITY", columns:[
    //                 {Header:"Meal Served Qty",accessor:"redMealServedQty"}, 
    //                 { Header:"A La Carte Served Qty",accessor:"redCarteServedQty"}
    //             ] },
    //             { Header: "REGULAR ELIGIBILITY", columns:[{Header:"Meal Served Qty",accessor:"regMealServedQty"},
    //             { Header:"A La Carte Served Qty",accessor:"regCarteServedQty"}], style: { textAlign: 'center', textTransform: 'capitalize' } } 
    //          ],
    //         data: this.state.data.map(item => {

    //             const itm={
    //                 date:item.date,
    //                 freeMealServedQty: item.freeMealServedQty,
    //                 freeCarteServedQty: item.freeCarteServedQty,
    //                 redMealServedQty: item.redMealServedQty,
    //                 redCarteServedQty: item.redCarteServedQty,
    //                 regMealServedQty: item.regMealServedQty,
    //                 regCarteServedQty: item.regCarteServedQty
    //             }
    //             return [{value: itm.date},{value: itm.freeMealServedQty}
    //             ,{value: itm.freeCarteServedQty},{value: itm.redMealServedQty},{value: itm.redCarteServedQty},{value: itm.regMealServedQty},{value: itm.regCarteServedQty}]
    //         })
    //       }]
    //     )
    //   }

      selectDate = (e) => {
        let date = {};
        let d = new Date(e);
        date.year = d.getFullYear();
        date.month = d.getMonth() + 1;
        this.refs.calendar.closeCalendar()
        console.log("Year and Month : ",date);
        const selectMonth = date.year+'-'+(('0' +(date.month)).slice(-2));
        const dt = moment(selectMonth, "YYYY-MM");
        const startDate = dt.startOf('month').format('YYYY-MM-DDT00:00:00');
        const endDate = dt.clone().endOf('month').format("YYYY-MM-DDT23:59:59");
        this.setState({ selectMonth, startDate, endDate }, () => {
            this.getData(this.state.mealTypes, this.state.startDate, this.state.endDate);
        });

        //document.getElementById("select_all").checked=false;
		 //this.props.onMealDateSelectionChange(date.year+''+(('0' +(date.month)).slice(-2)));
        
    }

    // filterGrade = () => {
    //      console.log("Calling to filterGrade");
    //      console.log("this.state.selectedOptions::::::::",this.state.selectedOptions);
    //      let filteredG;
    //      if(this.state.selectedOptions && this.state.selectedOptions.length > 0){
    //         filteredG = this.state.selectedOptions.map(item => item.value).join(',');
    //         this.setState({ selectedGrade: filteredG });
    //      }
    //   }
    
      renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }



render() {
    const gradeGroup=groupBy(getSchoolGrades(0,false),'value');
    const options = Object.keys(gradeGroup || {}).map(key => {
        const gradeGroupKey = gradeGroup[key]; 
        const firstItem = gradeGroupKey && gradeGroupKey[0]; 
        const label = firstItem ? firstItem.label : ''; 
        return {
          value: key,
          label: label
        };
      });
    return (<Fragment>
        
<div className="row">
    <div className="uploadFileInfo col-md-3">
        <label className="custom-label">Select Month</label>
        <div className="input-group">
            <Datetime ref='calendar' dateFormat="MMMM YYYY" timeFormat={false} closeOnSelect={true}
                isValidDate={(currentDate)=>{
                                                let minDate=moment();
                                                minDate.set({hour:0,minute:0,second:0,millisecond:0})
                                                currentDate.set({hour:0,minute:0,second:0,millisecond:0})
                                                return (minDate>=currentDate) ;
                                            }}
                defaultValue={currentMonth}
                onChange={this.selectDate.bind(this)} renderInput={this.renderInput}/>
        </div>
    </div>
    <div className="col-md-3">
        <label>Report for:</label>
        <div>
            <label class="rbcontainer">Lunch
            <input type="radio" name="edrange" value="Lunch" onChange={(e) => {
                this.setState({ mealTypes: e.target.value });
                this.props.state.mealTypes = e.target.value;
                this.getData("Lunch", this.state.startDate, this.state.endDate)
                }} checked={this.state.mealTypes === 'Lunch'} />
            <span className={`rbcheckmark${this.state.mealTypes === 'Lunch' ? ' rb-selected' : ''}`}></span>
        </label>
        <label class="rbcontainer">Breakfast
            <input type="radio" name="edrange" value="Breakfast" onChange={(e) => {
                this.setState({ mealTypes: e.target.value });
                this.props.state.mealTypes = e.target.value;

                this.getData("Breakfast", this.state.startDate, this.state.endDate) }} checked={this.state.mealTypes === 'Breakfast'} />
            <span className={`rbcheckmark${this.state.mealTypes === 'Breakfast' ? ' rb-selected' : ''}`}></span>
        </label>
        <label class="rbcontainer">Snack
            <input type="radio" name="edrange" value="Snack" onChange={(e) => {
                this.setState({ mealTypes: e.target.value });
                this.props.state.mealTypes = e.target.value;

                this.getData("Snack", this.state.startDate, this.state.endDate) }} checked={this.state.mealTypes === 'Snack'} />
            <span className={`rbcheckmark${this.state.mealTypes === 'Snack' ? ' rb-selected' : ''}`}></span>
        </label>
    </div>
  </div>

    <div className="col-md-3">
        <label htmlFor="selectBy">Grades: </label>
        <Select
            options={options}
            value={this.state.selectedOptions}
            onChange={(e) => {
                this.setState({ selectedOptions: e }, () => {
                    if(e && e.length > 0){
                        this.setState({selectedGrade : e.map(item => item.value).join(',')}, () => {
                            this.getData(this.state.mealTypes, this.state.startDate, this.state.endDate);
                        })
                    }else{
                        this.setState({selectedGrade : ""}, () => {
                            this.getData(this.state.mealTypes, this.state.startDate, this.state.endDate);
                        })
                    }
                })
            }}
            isMulti
        />
    </div>

    <div className="col-md-3">
        <label htmlFor="teacherNameInput">Teacher Name: </label>
        <input
            id="teacherNameInput"
            type="text"
            className="form-control"
            placeholder="e.g. Smith"
            value={this.state.teacherName}
            onChange={(e) => {
                this.setState({ teacherName: e.target.value }, () => {
                    this.getData(this.state.mealTypes, this.state.startDate, this.state.endDate);
                });
            }}
        />
    </div>
</div>
<div className="row">
                <div className="col-md-12">
                    <ReactTable className="-striped -highlight"
                        data={this.state.data}
                        columns={this.getColumns()}
                        defaultPageSize={10}
                   />
                </div>                
            </div>
     </Fragment>);
}
}
export default FRLReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/CliamReport/frlReport.jsx